import React, { useState } from 'react';
import { API_BASE_URL } from './TokenChecker';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    setStatus({ type: '', msg: '' });
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/password-reset/request/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      // Always show success message regardless of actual user existence
      if (res.ok) {
        setStatus({ type: 'success', msg: 'If the email exists, a reset link has been sent.' });
      } else {
        // Backend returns 200 even if not, but handle non-200 gracefully
        setStatus({ type: 'success', msg: 'If the email exists, a reset link has been sent.' });
      }
    } catch (_) {
      setStatus({ type: 'error', msg: 'Failed to send reset email. Try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-[#10A7F3]">Forgot Password</h2>
        <p className="mt-2 text-center text-sm text-gray-600">Enter your email to receive a reset link</p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {status.msg && (
            <div className={`mb-4 px-4 py-3 rounded ${status.type === 'error' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
              {status.msg}
            </div>
          )}
          <form className="space-y-6" onSubmit={onSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email address</label>
              <input id="email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#4299E1] focus:border-[#4299E1] sm:text-sm" />
            </div>
            <button type="submit" disabled={submitting} className={`w-full py-2 px-4 rounded-md text-white font-bold shadow ${submitting ? 'bg-gray-300' : 'bg-[#4299E1] hover:bg-[#3182CE]'}`}>
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
          </form>
          <div className="mt-4 text-center">
            <a href="/login" className="text-sm text-[#4299E1] hover:text-[#3182CE]">Back to login</a>
          </div>
        </div>
      </div>
    </div>
  );
}
